import Div100vh from "react-div-100vh";
import { ReactSVG } from "react-svg";
import wlhLogo from "../../../../assets/images/layout/wlh-header-logo.svg";
import rightCloud from "../../../../assets/images/layout/right-cloud.svg";
import poppetje from "../../../../assets/images/layout/use-desktop-splash-screen-poppetje.svg";

const MobileToDesktopSplashWarning = () => {
    return (
        <Div100vh className="w-full flex flex-col relative navy-blue-scrollbar overflow-x-hidden">
            <ReactSVG src={rightCloud} className="absolute right-0 -top-8 opacity-50 z-[-1]" />
            <div className="h-full w-full flex flex-col items-center justify-start gap-[3rem] pt-6">
                <ReactSVG src={wlhLogo} />
                <div className="text-standart-ocean text-center text-[2.125rem] font-bold leading-tight tracking-[0.0125rem]">
                    This app <br/> is best viewed <br/> on desktop
                </div>
                <ReactSVG src={poppetje} className="pl-[5rem]"/>
            </div>
        </Div100vh>
    )
}

export default MobileToDesktopSplashWarning;